import React from 'react';
import { logoutUser } from '../../utility/helper';

const OrderMonitorHeader: React.FC = () => {
  return (
    <>
      <header className="app-header fixed-top" style={{ background: '#260c0c' }}>
        <div className='d-flex align-items-center justify-content-between h-100'>
          <div className="container">
            <div className='d-flex align-items-center justify-content-between'>
              <div>
                <img style={{ maxWidth: '100px' }} className="logo-icon" src={"/assets/images/app-logo.svg"} alt="logo" />
              </div>
              <div className="app-utility-item app-user-dropdown dropdown dropdown-menu-end">
                <a className="dropdown-toggle d-flex align-items-center" id="user-dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                  </svg>
                </a>
                <ul className="dropdown-menu" aria-labelledby="user-dropdown-toggle">
                  <li>
                    <a className="dropdown-item" href="javascript:void(0)" onClick={() => logoutUser()}>Log Out</a>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </header>
    </>
  )
}
export default OrderMonitorHeader